<template>
  <div class="module-data-statistics-usage">
    <el-row style="padding-bottom:10px; border-bottom: 1px solid #e4e7ed;">
      <el-col :span="24">
        <el-button
          @click="$router.go(-1)"
          size="medium"
        >返回</el-button>

        <!-- <el-date-picker
          size="medium"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 240px;"
          :clearable="false"
          v-model="form.dateRange"
          @change="filterSearch"
        ></el-date-picker> -->
      </el-col>
    </el-row>
    <div class="title">{{moduleName}}使用统计</div>

    <div
      class="read-box el-table__body-wrapper"
      :style="{ height: windowHeight - 212 + 'px' }"
    >
      <div
        class="no_list_msg"
        v-if="isEmpty"
      >
        <img
          src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
          alt
        />
        <div>暂无数据</div>
      </div>
      <div
        class="table-wrapper"
        v-else
      >
        <div
          class="table-item"
          :key="idx"
          v-for="(item, idx) in dataList"
        >
          <div class="serial-number">{{idx + 1}}</div>
          <div class="avatar-wrapper">
            <span class="avatar">
              <img :src="item.avatar">
            </span>
            &nbsp;
            <span class="uname">{{item.userName}}</span>
          </div>
          <div class="count">创建
            <el-tooltip
              effect="dark"
              placement="top-start"
              :content="String(item.creationCount)"
            >
              <span>{{item.creationCount}}</span>
            </el-tooltip>
            次
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* utils */
import mixin from "@/mixins/windowResize";
import { schoolTypeConstants } from "@/utils/constants";

/* components */

/* api */
import { listAreaByParentCode } from "@/api/kitDataStatistics";
import { getModuleCreCountByDateScope } from "@/api/moduleDataStatistics";

export default {
  mixins: [mixin],
  components: {},
  data() {
    return {
      moduleName: this.$route.query.moduleName,
      isEmpty: false,
      // 是否正在加载数据 { Boolean }
      tabLoading: false,
      // 表格数据 { Array }
      dataList: [],
      form: {
        statisticsCode: this.$route.query.statisticsCode || "1209",
        dateRange: [this.$route.query.startDate, this.$route.query.endDate],
      },
      exportUrl: "",
    };
  },
  created() {
    this.getModuleCreCountByDateScope();
  },
  methods: {
    getModuleCreCountByDateScope() {
      let startDate = this.form.dateRange ? this.form.dateRange[0] : "";
      let endDate = this.form.dateRange ? this.form.dateRange[1] : "";
      let form = {
        statisticsCode: this.form.statisticsCode,
        startDate,
        endDate,
        schoolId: this.$route.query.id,
      };
      getModuleCreCountByDateScope(form)
        .then((res) => {
          let _res = res.data;
          if (_res.code != 200) return Promise.reject(_res.msg);
          else return _res.data;
        })
        .then((data) => {
          if (Array.isArray(data)) {
            this.dataList = data;
            if (this.dataList.length) this.isEmpty = false;
            else this.isEmpty = true;
            console.log(this.dataList);
          }
        });
    },

    // 修改 日期范围
    filterSearch() {
      this.getModuleCreCountByDateScope();
    },
  },
};
</script>

<style lang="scss" scoped>
.module-data-statistics-usage {
  padding: 12px;
  * {
    box-sizing: border-box;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    text-align: center;
    margin: 12px;
  }

  .no_list_msg {
    font-size: 14px;
    text-align: center;
    color: #999;
    overflow: hidden;
    img {
      margin-top: 50px;
    }
    div {
      margin-top: -50px;
    }
  }

  .table-wrapper {
    max-height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    .table-item {
      margin-right: 15px;
      margin-bottom: 15px;
      padding: 0 15px;
      width: 310px;
      line-height: 75px;
      height: 75px;
      background-color: rgb(236, 245, 255);
      border: 1px solid rgb(179, 216, 255);
      border-radius: 5px;
      display: flex;
      .serial-number {
        font-size: 24px;
        flex: 0 0 36px;
        min-width: 36px;
      }
      .avatar-wrapper {
        flex: 0 0 150px;
        width: 150px;
        .avatar {
          display: inline-block;
          border-radius: 50%;
          overflow: hidden;
          width: 50px;
          height: 50px;
          vertical-align: middle;
          img {
            width: 100%;
          }
        }

        .uname {
          color: rgb(64, 158, 255);
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 80px;
          vertical-align: top;
        }
      }
      .count {
        flex: 1;
        text-align: right;
        color: rgb(64, 158, 255);
        span {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 30px;
          height: 20px;
          line-height: 20px;
          vertical-align: top;
          margin-top: 28px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/moduleDataStatistics/usage.vue